import { createApp } from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/styles/tailwind.css';

library.add(faRightFromBracket);

const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);
app.use(store);
app.use(router);
app.provide('moment', moment);
app.mount('#app');
